import React from 'react'
import { Link } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { ChevronUp, Table, Grid } from 'react-feather';
import { ImageWithBasePath } from 'Core/components';
import { useDispatch, useSelector } from 'react-redux';
import { actions as mainActions } from 'Core/redux/main/slice';
import { actions as maintenanceActions } from './store/slice';
import { selectTileView } from './store/selectors';
import { isHeaderVisible } from 'Core/redux/main/selectors';


const { setToogleHeader } = mainActions;
const { setTileView } = maintenanceActions;

const MoldMaintenanceTopHead = () => {
    const dispatch = useDispatch();
    const data = useSelector(isHeaderVisible);
    const tileView = useSelector(selectTileView);
  
    const renderExcelTooltip = props => <Tooltip {...props}>Excel</Tooltip>;
    const renderCollapseTooltip = props => <Tooltip {...props}>Collapse</Tooltip>;
    const renderTileViewTooltip = props => (
      <Tooltip {...props}>{tileView ? 'Table View' : 'Tile View'}</Tooltip>
    );
  
  return (
    <>
      <ul className="table-top-head">
        <li>
          <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
            <Link
              data-bs-toggle="tooltip"
              data-bs-placement="top"
            >
              <ImageWithBasePath src="assets/img/icons/excel.svg" alt="img" />
            </Link>
          </OverlayTrigger>
        </li>
        <li>
          <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
            <Link
              to="#"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              id="collapse-header"
              className={data ? 'active' : ''}
              onClick={() => {
                dispatch(setToogleHeader(!data));
              }}
            >
              <ChevronUp />
            </Link>
          </OverlayTrigger>
        </li>
        <li>
          <OverlayTrigger placement="top" overlay={renderTileViewTooltip}>
            <Link
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              onClick={() => {
                dispatch(setTileView(!tileView));
              }}
            >
              {tileView ? <Table /> : <Grid />}
            </Link>
          </OverlayTrigger>
        </li>
      </ul>
     
    </>
  )
}

export default MoldMaintenanceTopHead